import React from 'react';
import styles from './ConfirmPaymentModal.module.css';
import {appText} from '../../assets/text/appText';
import Button from '../Buttons/Button';
import {ReactComponent as CheckIcon} from '../../assets/images/subscriotion_green_check.svg';
import {marketplaceText} from '../../pages/Subscription/Marketplace/marketplaceText';
import CloseXButton from '../Buttons/CloseXButton/CloseXButton';

export interface ConfirmPaymentPayload {
  uiType?: ConfirmPaymentModalType;
  planName: string;
  price: string;
  isAnnual?: boolean;
  quantity?: number;
  nextBillingDate?: string;
  description?: string;
  keyFeatures?: string[];
}

export type ConfirmPaymentModalType = 'planChange' | 'buyLicense';

interface Props {
  openingPayload?: ConfirmPaymentPayload;
  onAccept: () => void;
  onCancel: () => void;
}

const ConfirmPaymentModal = ({openingPayload, onAccept, onCancel}: Props) => {
  if (openingPayload?.uiType === 'planChange') {
    return (
      <div className={`${styles.modal} ${styles.planChange}`}>
        <div className={styles.container}>
          <CloseXButton onClick={onCancel} />
          <h2>{appText.confirmPaymentModalTitlePlan}</h2>
          <h6>{openingPayload?.planName}</h6>
          <h4>{openingPayload?.price}</h4>
          {/* <h6>{appText.nextBillingDate}</h6>
          <p>{openingPayload?.nextBillingDate}</p> */}
          <h6>{appText.keyFeatures}</h6>
          <ul>
            {openingPayload?.keyFeatures?.map((feature, index) => (
              <li key={index}>
                <CheckIcon />
                {feature}
              </li>
            ))}
          </ul>
          <div className={styles.buttons}>
            <Button onClick={onCancel} title={appText.cancel} uiType="text" />
            <Button onClick={onAccept} title={appText.confirmNewPlan} />
          </div>
        </div>
      </div>
    );
  } else
    return (
      <div className={`${styles.modal} ${styles.buyLicense}`}>
        <div className={styles.container}>
          <CloseXButton onClick={onCancel} />
          <h2>{appText.confirmPaymentModalTitleLicense}</h2>
          <h6>{appText.purchaseItem}</h6>
          <p>
            {openingPayload?.planName} (x{openingPayload?.quantity})
          </p>
          <h6>{appText.billing}</h6>
          <h4>{openingPayload?.price}</h4>
          <p className={styles.billingCycle}>
            {openingPayload?.isAnnual
              ? appText.billedAnnual
              : appText.billedMonthly}
          </p>
          <p className={styles.asterix}>* {marketplaceText.payNowInfo}</p>
          <div className={styles.buttons}>
            <Button onClick={onCancel} title={appText.cancel} uiType="text" />
            <Button onClick={onAccept} title={appText.payNow} />
          </div>
        </div>
      </div>
    );
};

export default ConfirmPaymentModal;
